import {ThemeDefinition} from "vuetify";

export const currentTheme: ThemeDefinition = {
  dark: false,
  colors: {
    background: '#FFFFFF',
    surface: '#FFFFFF',
    primary: '#3D405B',
    secondary: '#81B29A',
    tertiary: '#E07A5F',
    error: '#B00020',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FB8C00',
  },
}

const isConnexin = process.env.VUE_APP_FRAMEWORK_HOST === 'connexin';
export const font = isConnexin ? {
    name: 'Poppins',
    url: 'https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap'
  } : {
    name: 'PT Sans',
    url: 'https://fonts.googleapis.com/css2?family=PT+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap'
  };
